var n = function n(r, e) {
    return new Date(r.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()));
  },
  s = function s(r, e) {
    return function (t) {
      if (e) {
        if (r && t) return e(n(r, t));
        e(t);
      }
    };
  },
  c = function c(r, e) {
    return function (t) {
      if (e) {
        if (Array.isArray(r) && t) return e([n(r[0], t[0]), n(r[1], t[1])]);
        e(t);
      }
    };
  };
export { c as preserveTimeDateRangeSelect, s as preserveTimeDateSingleSelect };